export default {
    gadget_average_wireless_strength: "Intensidad inalámbrica media",
    gadget_daily_device_vin_count: "Recuento diario de dispositivos VIN",
    gadget_average_hdop: "Media Hdop",
    gadget_average_satellite_count: "Recuento medio de satélites",
    gadget_ignition_on_event_count: "Recuento de eventos de encendido",
    gadget_late_event_count: "Recuento de eventos tardíos",
    gadget_max_min_odometer_difference: "Max Min Diferencia cuentakilómetros",
    gadget_power_disconnect_event_count: "Recuento de eventos de desconexión de alimentación",
    gadget_low_battery_event_count: "Recuento de eventos de batería baja",
    gadget_low_total_event_count: "Recuento total de eventos",
    gadget_low_maintenance_limit_exceeded_count: "Recuento límite de mantenimiento superado",
    gadget_maintenance_warnigs: "Advertencias de Mantenimiento",
}